class LiveViews extends HTMLElement {
  constructor() {
    super();
    this.NUMBER_UPDATE_INTERVAL = 120000;
  }

  connectedCallback() {
    this.buildMessage(this.dataset.message, this.generateRandomInt());
  }

  buildMessage(message, viewsNumber) {
    this.messageContainer = this.querySelector(".live-views__content");
    this.messageContainer.innerHTML = message.replace('[views]', viewsNumber);
  }

  generateRandomInt() {

    let randomInt = Math.floor(Math.random() * 451) + 51;


    setInterval(() => {

      const change = Math.floor(Math.random() * 51) - 25;
      randomInt += change;


      randomInt = Math.max(51, Math.min(501, randomInt));

      this.buildMessage(this.dataset.message, randomInt); 

    }, this.NUMBER_UPDATE_INTERVAL);

    return randomInt;
  }
}

customElements.define('live-views', LiveViews);



class SiteLoader extends HTMLElement  {
  constructor() {
    super();
    this.body = document.body

    window.addEventListener("load", ()=>{
      this.hideLoader();
      this.removeAllLoaders();
    })
  }

  hideLoader() {
    this.body.setAttribute('site-loaded','')
  }

  removeAllLoaders(){
    const loadingEls = document.querySelectorAll('[skeleton-loading=""]');

    setTimeout(() => {
      loadingEls.forEach(el => {
        el.removeAttribute('skeleton-loading')
      })      
    }, 1500);
  }
}

customElements.define('site-loader', SiteLoader);



class DeliveryPredictor extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.currentDate = new Date();
        this.getCookie = key => document.cookie.split('; ').find(cookie => cookie.startsWith(`${key}=`)).split('=')[1];
        
        this.numDays = this.getCookie('localization') == "GB" 
          ? parseInt(this.getAttribute('uk-days')) || 2
          : parseInt(this.getAttribute('num-days')) || 5
        this.predictDeliveryDate();
    }

    connectedCallback() {
        this.render();
    }

predictDeliveryDate() {
    const deliveryDate = new Date(this.currentDate.getTime() + this.numDays * 24 * 60 * 60 * 1000);
    const nextDay = this.getCookie('localization') == "GB"
      ? new Date(deliveryDate.getTime() + 24 * 60 * 60 * 1000)
      : new Date(deliveryDate.getTime() + 24 * 10 * 60 * 60 * 1000)

    const options = { weekday: 'long', day: '2-digit', month: '2-digit' };
    
    const outputDate = deliveryDate.toLocaleDateString(undefined, options);
    const outputNextDay = nextDay.toLocaleDateString(undefined, options);

    const container = document.createElement('div');
    const formattedOutputDate = outputDate.replace(/(\d{2})\/(\d{2})/, '$2/$1'); // Swap day and month
    const formattedOutputNextDay = outputNextDay.replace(/(\d{2})\/(\d{2})/, '$2/$1'); // Swap day and month

    container.textContent = `${formattedOutputDate} - ${formattedOutputNextDay}`;

    // Clear existing content before appending
    this.shadowRoot.innerHTML = '';

    this.shadowRoot.appendChild(container);

    if (this.numDays > 2) {
        this.setAttribute('past3am', '');
    }
}





    render() {
        this.predictDeliveryDate();
    }
}

customElements.define('delivery-predictor', DeliveryPredictor);



class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.countdownText = null;
    this.intervalId = null;
  }

  connectedCallback() {
    this.countdownText = document.createElement('div');
    this.countdownText.className = 'countdown-text';
    this.appendChild(this.countdownText);
    this.startCountdown();
  }

  disconnectedCallback() {
    clearInterval(this.intervalId);
  }

  startCountdown() {
    const now = new Date();
    const targetTime = new Date(now);
    targetTime.setUTCHours(14); // Set target time to 3 PM (GMT+1)
    targetTime.setUTCMinutes(0);
    targetTime.setUTCSeconds(0);

    if (now > targetTime) {
      this.countdownText.innerHTML = '';
      DeliveryPredictor.setNumDays(3);
      return;
    }

    this.intervalId = setInterval(() => {
      const currentTime = new Date();
      const distance = targetTime - currentTime;

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.countdownText.innerHTML = `${hours}h ${minutes}m ${seconds}s`;

      if (distance <= 0) {
        clearInterval(this.intervalId);
        DeliveryPredictor.setNumDays(3);
        this.countdownText.innerHTML = '';
      }
    }, 1000);
  }
}

customElements.define('countdown-timer', CountdownTimer);



class RecentlyViewedProducts {
  constructor() {
    this.productData = null;
    this.numberOfProducts = 20;
  }

  async getProductData() {
    const script = document.getElementById('productJSONData');
    if (script) {
      try {
        this.productData = JSON.parse(script.textContent);
      } catch (error) {
        console.error('Error parsing product data:', error);
      }
    }
  }

  async setRecentlyViewedProducts() {
    if (!this.productData) {
      await this.getProductData();
    }
  
    if (this.productData) {
      const viewedProduct = {
        productID: this.productData.productID,
        productIsAvailable: this.productData.productIsAvailable,
        productVendor: this.productData.productVendor,
        productTitle: this.productData.productTitle,
        producthasMiltipleVariants: this.productData.producthasMiltipleVariants,
        productFirstAvailableVariantID: this.productData.productFirstAvailableVariantID,
        productImg: this.productData.productImg,
        productPriceClass: this.productData.productPriceClass,
        productPriceCurrent: this.productData.productPriceCurrent,
        productPriceWas: this.productData.productPriceWas,
        productUrl: this.productData.productUrl,
        productImageAltText: this.productData.productImageAltText
      };
      let recentProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
      const index = recentProducts.findIndex((p) => p.productUrl === viewedProduct.productUrl);
      if (index >= 0) {
        recentProducts.splice(index, 1);
      }
      recentProducts.unshift(viewedProduct);
      if (recentProducts.length > this.numberOfProducts) {
        recentProducts = recentProducts.slice(0, this.numberOfProducts);
      }
      localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentProducts));
    }
  
    this.getRecentlyViewedProducts();
  }  

  async init() {
    await this.setRecentlyViewedProducts();
    this.getRecentlyViewedProducts();
  }

  generateProductQuickBuy(product){
    let quickBuy = `
      <div class="quick-add no-js-hidden">
        <modal-opener data-modal="#QuickAdd-${product.productID}">
            <button id="quick-add-${product.productID}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--primary-1 " aria-haspopup="dialog" aria-labelledby="quick-add-${product.productID}-submit title--${product.productID}" data-product-url="${product.productUrl}?pr_prod_strat=use_description&amp;pr_rec_id=07cf052f1&amp;pr_rec_pid=${product.productID}&amp;pr_ref_pid=${product.productID}&amp;pr_seq=uniform">
              <span class="tablet-hide">Quick View</span>
              <span class="icon large-up-hide">
                  <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                    <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path>
                  </svg>
              </span>
              <div class="loading-overlay__spinner hidden">
                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
              </div>
            </button>
        </modal-opener>
        <quick-add-modal id="QuickAdd-${product.productID}" class="quick-add-modal">
          <div
            role="dialog"
            aria-modal="true"
            class="quick-add-modal__content global-settings-popup" 
            tabindex="-1"
          >
            <button
              id="ModalClose-${product.productID}"
              type="button"
              class="quick-add-modal__toggle"
              aria-label="{{ 'accessibility.close' | t }}"
            >
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </path>
            </svg>
            </button>
            <div id="QuickAddInfo-${product.productID}" class="quick-add-modal__content-info"></div>
          </div>
      </quick-add-modal>
      </div>`
    return quickBuy
  }



  getRecentlyViewedProducts() {
    const recentProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
    const recentlyViewedHtml = recentProducts
      .reverse() // reverse the array to show latest added items first
      .map(
        (item) => `
          <li class="swiper-slide recently-viewed-item">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media">
                <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 125.0%;">
                <button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${item.productUrl}" data-swaction="addToWishlist" data-product-id="${item.productID}" data-variant-id="${item.productFirstAvailableVariantID}" data-product-url="https://naturesbalanceuk.myshopify.com${item.productUrl}"></button>
                ${this.generateProductQuickBuy(item)}
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <img class="motion-reduce" src='${item.productImg}' loading="lazy" alt="${item.productImageAltText}"/>
                    </div>
                  </div>
                </div>
  
                <div class="card__content">
                  <div class="card__information">
                    <span class="card__vendor card-vendor light">${item.productVendor}</span>
                    <h3 class="card__heading subtitle" class="full-unstyled-link"><a class="card__heading subtitle" href="${item.productUrl}">${item.productTitle}</a></h3>
                    <div class="card-information">
                      <span class="caption-large light"></span>
                      <div class="klaviyo-star-rating-widget" data-id="${item.productID}" data-product-title="${item.productTitle}"></div>
                      <div class="price ${item.productPriceClass}">
                        <div class="price__regular">
                          <span class="visually-hidden visually-hidden--inline">Regular price</span>
                          <span class="price-item price-item--regular">${item.productPriceCurrent}</span>
                        </div>

                        <div class="price__sale">
                          <span class="visually-hidden visually-hidden--inline">Sale price</span>
                          <span class="price-item price-item--sale price-item--last">${item.productPriceWas}</span>
                          <span class="visually-hidden visually-hidden--inline">Regular price</span>
                          <span><s class="price-item price-item--regular">${item.productPriceCurrent}</s></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        `
      )
      .join('');
    const recentlyViewedContainer = document.querySelector('.recently-viewed-container');
    if(recentlyViewedContainer){
    const fullContent = recentlyViewedContainer.getElementsByClassName('js-recently-viewed');

    if (fullContent.length > 0 && recentProducts.length > 0) {
      recentlyViewedContainer.classList.remove('hidden');
      fullContent[0].innerHTML = recentlyViewedHtml;
    }
  }
  }
  
}

const recentlyViewedProducts = new RecentlyViewedProducts();
recentlyViewedProducts.init();

class BackToTopButton extends HTMLElement {
  constructor() {
    super();
    this.body = document.body;
    this.scrollYThreshold = this.dataset.threshold;

    this.addEventListener('click', this.scrollToTop.bind(this));
    window.addEventListener('scroll', this.toggleVisibility.bind(this));
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleVisibility() {
    const footer = document.querySelector('footer.footer');
    const currentScrollY = window.scrollY;

    if (currentScrollY > this.scrollYThreshold && currentScrollY <= footer.offsetTop) {
      this.removeAttribute('hidden');
    } else {
      this.setAttribute('hidden', '');
    }
  }
}

customElements.define('back-to-top', BackToTopButton);



class MegaMenu extends HTMLElement {
  constructor() {
      super();
      this.activeLink = null;
      this.activeMenu = null;
      this.header = document.querySelector('.header');
      this.mainSearch = null;
      this.links = this.header.querySelectorAll('.header__menu-item');
      this.menuContainers = Array.from(document.querySelectorAll('.mega-menu-container'));
      this.menus = Array.from(document.querySelectorAll('mega-menu'));

      this.openMenu = this.openMenu.bind(this);
      this.closeMenu = this.closeMenu.bind(this);
  }

  connectedCallback() {
      this.setTargetLinksAsMegaLinks();
      this.megaMenuLinks = Array.from(this.header.querySelectorAll('.mega-menu-link'));

      this.megaMenuLinks.forEach((link) => {
          if (link != this.activeLink) link.addEventListener('mouseenter', () => this.closeMenu());
          link.addEventListener('mouseenter', () => this.openMenu(link.dataset.menu));
      });

      this.links.forEach((link) => {
          link.addEventListener('mouseenter', () => {
              if (link !== this.activeLink) {
                  this.closeMenu();
              }
          });
      });
    
      this.addEventListener('mouseleave', (e) => {
          this.closeMenu();
      });

      document.addEventListener('DOMContentLoaded', () => {
          this.decorateMenuLinks();
      });

      // ADMIN EVENT LISTENERS
      if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
              const targetSection = e.target.closest('.shopify-section');
              const targetMegamenu = targetSection.querySelector('mega-menu');
              if (targetMegamenu) this.openMenu(targetMegamenu.id);
          });

          document.addEventListener('shopify:section:select', (e) => {
              const targetMegamenu = e.target.querySelector('mega-menu');
              if (targetMegamenu) this.openMenu(targetMegamenu.id);
          });

          document.addEventListener('shopify:section:deselect', (e) => {
              this.closeMenu();
          });
      }
  }

  openMenu(targetId) {
      if (!targetId) return;
      const menu = document.getElementById(targetId);
      const link = document.querySelector(`[data-menu=${targetId}]`);

      if (this.activeMenu && this.activeMenu != menu) {
          this.closeMenu();
      } else {
          this.activeMenu = menu;
          this.activeLink = link;
          if (this.activeMenu != null) {
              this.activeLink.setAttribute('open', '');
              this.activeMenu.setAttribute('open', '');
              menu.focus();
          }
      }
  }

  setTargetLinksAsMegaLinks() {
      this.links.forEach(link => {
          if (link.dataset.menu == this.id) link.classList.add('mega-menu-link');
      });
  }

  decorateMenuLinks() {
      this.megaMenuLinks.forEach((megaLink) => {
          if (!megaLink.querySelector('.icon')) {
              const megaMenuIcon = document.createElement("div");
              megaMenuIcon.classList.add('icon');
              megaMenuIcon.innerHTML = `
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-mega-menu">
                  <path d="M3.5 6L7.20455 9.67453C7.64205 10.1085 8.35795 10.1085 8.79545 9.67453L12.5 6" stroke="#131212" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>`
              megaLink.appendChild(megaMenuIcon);
          }
      });
  }

  closeMenu() {
      if (this.activeMenu) {
          this.activeMenu.removeAttribute('open');
          this.activeLink.removeAttribute('open');
          this.activeMenu = null;
          this.activeLink = null;
          return;
      }
  }
}
  
  customElements.define('mega-menu', MegaMenu);



class LocalizationTextHandler {
    constructor() {
        this.textContainers = document.querySelectorAll('.js-location-based-text');
        this.currentLocalization = this.getCookie('localization');
        if (this.currentLocalization != 'GB') {
            this.changeText();
        }
    }

    changeText() {
        this.textContainers.forEach(container => {
            const newText = container.getAttribute('global-text');
            container.innerHTML = newText;
        });
    }

    getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split('=').map(c => c.trim());
            if (cookieName === name) {
                return cookieValue;
            }
        }
        return null;
    }
}

// Instantiate the LocalizationTextHandler
const localizationTextHandler = new LocalizationTextHandler();



document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const activeVendor = urlParams.get('q');

  if (!activeVendor) return;

  const active = decodeURIComponent(activeVendor).toLowerCase();

  document.querySelectorAll('.grid-menu--brands a').forEach(link => {
    const linkParams = new URLSearchParams(link.search);
    const vendor = linkParams.get('q');

    if (!vendor) return;

    const linkVendor = decodeURIComponent(vendor).toLowerCase();

    if (active === linkVendor) {
      link.classList.add('header__active-menu-item');
    }
  });
});